import {Injectable, OnInit} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {AngularFireMessaging} from '@angular/fire/messaging';
import {tap} from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class FcmSetupService {

    public receivedMessage: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]);
    public currentMessage: BehaviorSubject<any> = new BehaviorSubject<any>(null);
    public registeredToken: BehaviorSubject<string> = new BehaviorSubject<string>('');

    constructor(private angularFireMessaging: AngularFireMessaging) {
        try {
            this.requestPermission().subscribe(() => {
                console.log('permission request is work');
            });

            this.angularFireMessaging.tokenChanges.subscribe(token => {
                this.registeredToken.next(token);
                console.log(token);
            }, error => {

            });
        } catch (e) {
            console.log(e);
        }
    }

    requestPermission() {
        return this.angularFireMessaging.requestToken.pipe(
            tap(token => {
                this.registeredToken.next(token);
            })
        );
    }

    listenForMessageFcm() {
        this.angularFireMessaging.messages.subscribe(payload => {
            if (payload) {
                try {
                    console.log('input message from fcm message setup');
                    this.currentMessage.next(payload);
                    let storage = localStorage.getItem('messages');
                    let store = storage ? JSON.parse(storage) : [];
                    store = [payload, ...store];
                    this.receivedMessage.next(store);
                    this.currentMessage.next(payload);
                    localStorage.setItem('messages', JSON.stringify(store));
                } catch (e) {
                    console.error(e);
                }
            }
        });
    }

    deleteToken() {
        if (this.registeredToken.getValue()) {
            this.angularFireMessaging.deleteToken(this.registeredToken.getValue());
            this.registeredToken.next(null);
        }
    }

}
